module.exports = __webpack_public_path__ + "img/selecttest-JD.78db4928.svg";